"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIamBaseUrl = exports.getOMAuthRedirectUrlCookieName = exports.getOMIAMCookieName = exports.getIAMCookieGrantType = exports.getAPIKeyGrantType = exports.isCloudEnvironment = exports.isCloudUser = exports.isValidEmailFormat = exports.isValidGenericFormat = exports.isSandboxAllowListFormat = exports.isIBMerFormat = exports.AuthEnvironmentUrls = exports.RHMAction = exports.RHMResource = exports.AuthEnvironment = void 0;
var email_validator_1 = require("email-validator");
/*
 * The different auth environments that are availble. These values are used as params for other functions
 */
var AuthEnvironment;
(function (AuthEnvironment) {
    AuthEnvironment["PROD"] = "PROD";
    AuthEnvironment["PREPROD"] = "PREPROD";
    AuthEnvironment["DEV"] = "DEV";
    AuthEnvironment["PROD_RH"] = "PROD_RH";
    AuthEnvironment["PREPROD_RH"] = "PREPROD_RH";
    AuthEnvironment["DEV_RH"] = "DEV_RH";
    AuthEnvironment["IBMCLOUDPROD"] = "IBMCLOUDPROD";
    AuthEnvironment["IBMCLOUDPREPROD"] = "IBMCLOUDPREPROD";
    AuthEnvironment["IBMCLOUDDEV"] = "IBMCLOUDDEV";
    AuthEnvironment["IBMCLOUDPROD_RH"] = "IBMCLOUDPROD_RH";
    AuthEnvironment["IBMCLOUDPREPROD_RH"] = "IBMCLOUDPREPROD_RH";
    AuthEnvironment["IBMCLOUDDEV_RH"] = "IBMCLOUDDEV_RH";
})(AuthEnvironment = exports.AuthEnvironment || (exports.AuthEnvironment = {}));
var RHMResource;
(function (RHMResource) {
    RHMResource["ACCOUNT_BILLING"] = "account.billing";
    RHMResource["ACCOUNT_SETTINGS"] = "account.settings";
    RHMResource["ACCOUNT_MEMBERSHIP"] = "account.membership";
    RHMResource["ACCOUNT_ENTITLEMENTS"] = "account.entitlements";
    RHMResource["ACCOUNT_CLUSTERS"] = "account.clusters";
    RHMResource["ACCOUNT_PRIVATE_CATALOG"] = "account.privateCatalog";
    RHMResource["ACCOUNT_USERSUPPORT_CASES"] = "account.userSupportCases";
    RHMResource["ACCOUNT_SUPPORT_CASES"] = "account.accountSupportCases";
    RHMResource["ACCOUNT_SERVICE_IDS"] = "account.serviceIds";
    RHMResource["ACCOUNT_TAGS"] = "account.tags";
    RHMResource["CONTROL_ACCESS"] = "control.access";
    RHMResource["CONTROL_ACCOUNTS"] = "control.accounts";
    RHMResource["CONTROL_BILLING"] = "control.billing";
    RHMResource["CONTROL_DISCOUNTS"] = "control.discounts";
    RHMResource["CONTROL_INVOICE"] = "control.billing.customer";
    RHMResource["CONTROL_VENDOR_INVOICE"] = "control.billing.vendor";
    RHMResource["CONTROL_BILLING_JOBS"] = "control.billing.jobs";
    RHMResource["CONTROL_ENTITLEMENTS"] = "control.entitlements";
    RHMResource["CONTROL_PRODUCTS"] = "control.products";
    RHMResource["CONTROL_CLUSTERS"] = "control.clusters";
    RHMResource["CONTROL_OPERATOR"] = "control.operator";
    RHMResource["CONTROL_CATALOG"] = "control.catalog";
    RHMResource["VENDOR_PRODUCT_EDITOR"] = "vendor.productEditor";
    RHMResource["VENDOR_RUNTIME_USAGE"] = "vendor.runtimeUsage";
    RHMResource["VENDOR_PRIVATE_OFFERS"] = "vendor.privateOffers";
    RHMResource["VENDOR_LEGAL"] = "vendor.legal";
    RHMResource["SUPPORT_AGENT_CASE"] = "support.agentCase";
    RHMResource["SUPPORT_AGENT_CASELIST"] = "support.agentCaseList";
})(RHMResource = exports.RHMResource || (exports.RHMResource = {}));
var RHMAction;
(function (RHMAction) {
    RHMAction["READ"] = "read";
    RHMAction["MANAGE"] = "manage";
})(RHMAction = exports.RHMAction || (exports.RHMAction = {}));
/*
 * List of URLs for the authn and authz services. Users shoudln't need to use these directly
 */
exports.AuthEnvironmentUrls = {
    PROD: {
        login: 'https://marketplace.redhat.com/api-security/om-auth/login',
        logout: 'https://marketplace.redhat.com/api-security/om-auth/logout',
        publicKey: 'https://marketplace.redhat.com/api-security/om-auth/token/public-key',
        token: 'https://marketplace.redhat.com/api-security/om-auth/token',
        rhmPermissionCheck: 'https://marketplace.redhat.com/account/api/v1/permission/check'
    },
    PREPROD: {
        login: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/login',
        logout: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/logout',
        publicKey: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/token/public-key',
        token: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/token',
        rhmPermissionCheck: 'https://sandbox.marketplace.redhat.com/account/api/v1/permission/check'
    },
    DEV: {
        login: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/login',
        logout: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/logout',
        publicKey: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/token/public-key',
        token: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/token',
        rhmPermissionCheck: 'https://localhost.marketplace.redhat.com:3001/account/api/v1/permission/check'
    },
    PROD_RH: {
        login: 'https://marketplace.redhat.com/api-security/om-auth/login',
        logout: 'https://marketplace.redhat.com/api-security/om-auth/logout',
        publicKey: 'https://marketplace.redhat.com/api-security/om-auth/token/public-key',
        token: 'https://marketplace.redhat.com/api-security/om-auth/token',
        rhmPermissionCheck: 'https://marketplace.redhat.com/account/api/v1/permission/check'
    },
    PREPROD_RH: {
        login: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/login',
        logout: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/logout',
        publicKey: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/token/public-key',
        token: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/token',
        rhmPermissionCheck: 'https://sandbox.marketplace.redhat.com/account/api/v1/permission/check'
    },
    DEV_RH: {
        login: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/login',
        logout: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/logout',
        publicKey: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/token/public-key',
        token: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/token',
        rhmPermissionCheck: 'https://localhost.marketplace.redhat.com:3001/account/api/v1/permission/check'
    },
    IBMCLOUDPROD: {
        login: 'https://marketplace.redhat.com/api-security/om-auth/cloud/login',
        logout: 'https://marketplace.redhat.com/api-security/om-auth/cloud/logout',
        publicKey: 'https://marketplace.redhat.com/api-security/om-auth/cloud/token/public-key',
        token: 'https://marketplace.redhat.com/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://marketplace.redhat.com/account/api/v1/permission/check'
    },
    IBMCLOUDPREPROD: {
        login: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/login',
        logout: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/logout',
        publicKey: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/token/public-key',
        token: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://sandbox.marketplace.redhat.com/account/api/v1/permission/check'
    },
    IBMCLOUDDEV: {
        login: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/login',
        logout: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/logout',
        publicKey: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/token/public-key',
        token: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://localhost.marketplace.redhat.com:3001/account/api/v1/permission/check'
    },
    IBMCLOUDPROD_RH: {
        login: 'https://marketplace.redhat.com/api-security/om-auth/cloud/login',
        logout: 'https://marketplace.redhat.com/api-security/om-auth/cloud/logout',
        publicKey: 'https://marketplace.redhat.com/api-security/om-auth/cloud/token/public-key',
        token: 'https://marketplace.redhat.com/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://marketplace.redhat.com/account/api/v1/permission/check'
    },
    IBMCLOUDPREPROD_RH: {
        login: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/login',
        logout: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/logout',
        publicKey: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/token/public-key',
        token: 'https://sandbox.marketplace.redhat.com/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://sandbox.marketplace.redhat.com/account/api/v1/permission/check'
    },
    IBMCLOUDDEV_RH: {
        login: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/login',
        logout: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/logout',
        publicKey: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/token/public-key',
        token: 'https://localhost.marketplace.redhat.com:3003/api-security/om-auth/cloud/token',
        rhmPermissionCheck: 'https://localhost.marketplace.redhat.com:3001/account/api/v1/permission/check'
    }
};
var cloudAllowListFormat = new RegExp('^[\\w-\\.+]+\\+[\\w-\\.+]+@mail.test(?:.([a-z]{2,}))?.ibm.com$');
var ibmerFormat = new RegExp('^[\\w-\\.+]+@(?:([a-z]{2,}).)?ibm.com$');
function isIBMerFormat(email) {
    return ibmerFormat.test(email);
}
exports.isIBMerFormat = isIBMerFormat;
function isSandboxAllowListFormat(email) {
    return cloudAllowListFormat.test(email);
}
exports.isSandboxAllowListFormat = isSandboxAllowListFormat;
function isValidGenericFormat(email) {
    return email_validator_1.validate(email);
}
exports.isValidGenericFormat = isValidGenericFormat;
function isValidEmailFormat(email, authEnvironment) {
    if (authEnvironment === AuthEnvironment.IBMCLOUDPROD_RH ||
        authEnvironment === AuthEnvironment.PROD_RH) {
        return isValidGenericFormat(email);
    }
    return isSandboxAllowListFormat(email) || isIBMerFormat(email);
}
exports.isValidEmailFormat = isValidEmailFormat;
/* istanbul ignore next */
function isCloudUser(email) {
    return (isSandboxAllowListFormat(email) ||
        (email.startsWith('bluemix_ui_') && email.endsWith('@mailinator.com')));
}
exports.isCloudUser = isCloudUser;
/*
 * Returns the name of the cookie frontend applications can look for to determine if a user has logged in or not.
 */
function isCloudEnvironment(authEnvironment) {
    return (authEnvironment === AuthEnvironment.IBMCLOUDPREPROD ||
        authEnvironment === AuthEnvironment.IBMCLOUDPROD ||
        authEnvironment === AuthEnvironment.IBMCLOUDDEV ||
        authEnvironment === AuthEnvironment.IBMCLOUDPROD_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDPREPROD_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDDEV_RH);
}
exports.isCloudEnvironment = isCloudEnvironment;
function getAPIKeyGrantType(authEnvironment) {
    return isCloudEnvironment(authEnvironment)
        ? 'urn:ibm:params:oauth:grant-type:apikey'
        : 'urn:ibm:params:oauth:grant-type:om-apikey';
}
exports.getAPIKeyGrantType = getAPIKeyGrantType;
function getIAMCookieGrantType(authEnvironment) {
    return isCloudEnvironment(authEnvironment)
        ? 'urn:ibm:params:oauth:grant-type:iam-cookie'
        : 'urn:ibm:params:oauth:grant-type:om-iam-cookie';
}
exports.getIAMCookieGrantType = getIAMCookieGrantType;
function getOMIAMCookieName(authEnvironment) {
    if (authEnvironment === AuthEnvironment.IBMCLOUDPREPROD ||
        authEnvironment === AuthEnvironment.PREPROD ||
        authEnvironment === AuthEnvironment.PREPROD_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDPREPROD_RH)
        return 'om-iam-pre';
    if (authEnvironment === AuthEnvironment.IBMCLOUDDEV ||
        authEnvironment === AuthEnvironment.DEV ||
        authEnvironment === AuthEnvironment.DEV_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDDEV_RH)
        return 'om-iam-dev';
    return 'om-iam';
}
exports.getOMIAMCookieName = getOMIAMCookieName;
/*
 * Returns the name of the cookie frontend applications can look for to get the redirect url after user has registered.
 */
function getOMAuthRedirectUrlCookieName(authEnvironment) {
    if (authEnvironment === AuthEnvironment.IBMCLOUDPREPROD ||
        authEnvironment === AuthEnvironment.PREPROD ||
        authEnvironment === AuthEnvironment.PREPROD_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDPREPROD_RH)
        return 'om-auth-redirect-url-pre';
    if (authEnvironment === AuthEnvironment.IBMCLOUDDEV ||
        authEnvironment === AuthEnvironment.DEV ||
        authEnvironment === AuthEnvironment.DEV_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDDEV_RH)
        return 'om-auth-redirect-url-dev';
    return 'om-auth-redirect-url';
}
exports.getOMAuthRedirectUrlCookieName = getOMAuthRedirectUrlCookieName;
/*
 * Returns iamBaseUrl for cloud environment
 */
function getIamBaseUrl(authEnvironment) {
    if (authEnvironment === AuthEnvironment.IBMCLOUDPROD_RH ||
        authEnvironment === AuthEnvironment.IBMCLOUDPROD)
        return 'https://iam.cloud.ibm.com';
    return 'https://iam.test.cloud.ibm.com';
}
exports.getIamBaseUrl = getIamBaseUrl;
